<template>
  <div class="forgot-password-view py-5">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center text-xl bold my-5 text-uppercase">{{$t('auth.forgotPassword')}}</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">
            <div class="forgot-password-form">
              <div v-if="formError" class="mb-4">
                <b-alert show variant="danger">
                  <span class="text-sm">{{formError}}</span>
                </b-alert>
              </div>
              <div v-if="resetPasswordSentSuccess" class="mb-4">
                <b-alert show variant="success">
                  <span class="text-sm">{{$t('auth.resetPasswordSent')}}</span>
                </b-alert>
              </div>
              <div class="form">
                <ValidationObserver ref="observer" v-slot="{ invalid }">
                  <b-form @submit="onSubmit" @submit.stop.prevent>
                    <div class="mb-5">
                      <validation-provider rules="required|email" v-slot="{ errors }">
                        <b-input-group id="group-email">
                          <b-input-group-prepend is-text>
                            <b-icon icon="at"></b-icon>
                          </b-input-group-prepend>
                          <b-form-input id="email"
                                        class="text-sm"
                                        v-model="form.email"
                                        type="email"
                                        :placeholder="$t('forms.emailAddress')"
                                        required
                          ></b-form-input>
                        </b-input-group>
                        <span class="form-error text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="button-container">
                      <b-button type="submit"
                                :disabled="invalid || formSending"
                                variant="primary"
                                class="btn-rounded px-5 py-2 d-flex justify-content-center align-items-center">
                        <span class="text-md text-uppercase">{{$t('auth.request')}}</span>
                        <b-spinner v-if="formSending" type="grow" small class="ml-3"></b-spinner>
                      </b-button>
                    </div>
                  </b-form>
                </ValidationObserver>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { i18n } from 'vue-lang-router';

extend('required', {
  ...required,
  message: i18n.t('forms.thisFieldIsRequired'),
});
extend('email', {
  ...email,
  message: i18n.t('forms.emailNotValid'),
});

export default {
  metaInfo() {
    return {
      title: `${this.$t('auth.forgotPassword')} - Nissens Support`,
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        email: '',
      },
      formSending: false,
      resetPasswordSentSuccess: false,
      formError: '',
    };
  },
  mounted() {
    if (this.$store.state.user.status.loggedIn) {
      this.$router.push('/');
    }
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate().then(() => {
        this.formError = '';
        this.formSending = true;
        this.resetPasswordSentSuccess = false;
        this.$store.dispatch('user/SEND_RESET_PASSWORD', { email: this.form.email }).then(() => {
          this.form.email = '';
          this.formSending = false;
          this.resetPasswordSentSuccess = true;
        }).catch((error) => {
          this.formSending = false;
          this.formError = error;
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.forgot-password-view ::v-deep {
  form {
    .input-group-prepend > div {
      background-color: white;
    }
    input {
      padding: .8rem 1rem;
      height: unset;
    }
    svg {
      color: #c7c7c7;
    }
  }
  .password-container {
    margin-bottom: 50px;
  }
  .button-container {
    display: flex;
    justify-content: center;
  }
  .form-error {
    color: $tertiary;
  }
}
</style>
